<template>
  <v-btn
    v-tooltip="this.$t('components.HelpButton.title')"
    class="help-button"
    :href="supportLink"
    target="_blank"
    :height="size"
    :width="size"
    depressed
    rounded
    link
    @click="openLink"
  >
    <DsIcon
      name="faq"
      size="small"
      class="help-button__faq-icon"
    />
  </v-btn>
</template>

<script>
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import { DsIcon } from '@ds/icons';

const buttonSize = '32';

export default {
  name: 'HelpButton',
  components: {
    DsIcon,
  },
  data() {
    return {
      size: buttonSize,
      supportLink: 'https://suporte.stilingue.com.br/hc/pt-br/categories/4445903286556-Outros',
    };
  },
  methods: {
    openLink() {
      trackEventWithUserProperties('ST Dashboard HelpCenterButton Click');
    },
  },
};
</script>

<style scoped lang="scss">
.help-button {
  margin: 0 12px;
}

.v-btn {
  min-width: 32px !important;
  min-height: 32px !important;
  padding: 0 !important;
}
</style>
